import { render, staticRenderFns } from "./Section7.vue?vue&type=template&id=1270f906&scoped=true&"
import script from "./Section7.vue?vue&type=script&lang=js&"
export * from "./Section7.vue?vue&type=script&lang=js&"
import style0 from "./Section7.vue?vue&type=style&index=0&id=1270f906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1270f906",
  null
  
)

export default component.exports